var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSlideDer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M18 35C8.612 35 1 27.388 1 18S8.612 1 18 1s17 7.612 17 17-7.612 17-17 17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.375 17.5L13 23.875 15.163 26l8.462-8.5L15.163 9 13 11.125l6.375 6.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlideDer);
export default __webpack_public_path__ + "static/media/arrow-slide-der.8781473d92f46fcfcb52ef2d3fa5b066.svg";
export { ForwardRef as ReactComponent };